import { Box, ListItemText, useTheme } from '@mui/material'
import CardListItem from './CardListItem'
import { MuiMarkdown } from 'mui-markdown'
import AnimatedBox from './Motion/AnimatedBox'
import StyledIcon, { Props as StyledIconProps } from './StyledIcon'
interface Props {
  text?: string
  subText?: string | React.ReactNode
  subTextType?: 'secondaryText' | 'textButton'
  onClick?: () => void
  rightIcon?: 'arrow' | 'menu' | 'checked' | 'unchecked'
  rightComponent?: React.ReactNode
  icon?: StyledIconProps['name']
  leftComponent?: React.ReactNode
  color?: StyledIconProps['color']
  menuAnchorId?: string
  placeHolder?: string
}

export function selectedIcon(selected: boolean) {
  return selected ? 'checked' : 'unchecked'
}

function CardButton(props: Props) {
  const { menuAnchorId, text, subText, onClick, icon, leftComponent, rightIcon,
    color, placeHolder, subTextType, rightComponent } = props

  const theme = useTheme()

  const primaryText = text || placeHolder
  const primaryFontStyle = !text
    ? { color: 'text.secondary', fontStyle: 'italic' }
    : { color }

  const secondaryFontStyle = subTextType === 'textButton'
    ? { color: 'primary.main', fontWeight: 'medium', fontSize: theme.typography.body1.fontSize, mt: 1 }
    : {}

  return (
    <CardListItem onClick={onClick} menuAnchorId={menuAnchorId}>
      {leftComponent || icon && <Box sx={{ ml: -1, display: 'flex' }}>
        {icon && <StyledIcon name={icon} color={color} />}
        {leftComponent}
      </Box>}

      <ListItemText
        primary={<MuiMarkdown>{primaryText}</MuiMarkdown>}
        secondary={subText}
        primaryTypographyProps={primaryFontStyle}
        secondaryTypographyProps={secondaryFontStyle}
      />

      {rightComponent && <Box sx={{ mr: -1, display: 'flex', pointerEvents: 'none' }}>
        {rightComponent}
      </Box>}

      {rightIcon &&
        <AnimatedBox
          key={rightIcon}
          sx={{ mr: -1, display: 'flex', pointerEvents: 'none' }}
          entering={rightIcon === 'checked' ? ['zoom', 'fade'] : undefined}
          durationMs={800}
        >
          {rightIcon === 'arrow' && <StyledIcon name='forward' size={24} color={'secondary.dark'} />}
          {rightIcon === 'menu' && <StyledIcon name='dots' size={24} color='primary' />}
          {rightIcon === 'checked' && <StyledIcon name='checkedBox' size={32} color='primary' />}
          {rightIcon === 'unchecked' && <StyledIcon name='uncheckedBox' size={32} color='darkGray.main' />}
        </AnimatedBox>
      }
    </CardListItem>
  )
}

export default CardButton